import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { Divider as RNPDivider } from 'react-native-paper';

import { Caption } from '@components/Typography';

type DividerProps = React.ComponentProps<typeof RNPDivider>;

export default function Divider(props: DividerProps) {
  return <RNPDivider {...props} />;
}

type TextDividerProps = {
  text: string;
};

export function TextDivider({ text }: TextDividerProps) {
  return (
    <View style={styles.container}>
      <Divider style={styles.divider} />
      <Caption>{text}</Caption>
      <Divider style={styles.divider} />
    </View>
  );
}

export function ListItemPartialDivider() {
  return <Divider style={styles.listItemPartial} />;
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  divider: {
    flex: 1,
    marginHorizontal: 10,
    width: '100%',
  },
  listItemPartial: {
    alignSelf: 'center',
    marginVertical: 10,
    width: '50%',
  },
});
